import React from "react";

const Imprint = () => {
  return ( 
        <div id="imprint">
            <h3>Imprint</h3>
            <p>Name: Johannes Menz</p>
            <p>Email: johannesmnz@gmail.com</p>
        </div>
  );
};

export default Imprint;
